import type { Locale } from "./i18n";

const words = {
  fr: {
    animals: ["Timbu", "Capybara", "Toucan", "Crabe", "Jaguar", "Colibri", "Gecko", "Saci"],
    traits: ["Éclair", "Turbo", "Futé", "Rapide", "Malin", "Volant", "Agile", "Espiègle"],
  },
  "pt-BR": {
    animals: ["Timbu", "Capivara", "Tucano", "Arara", "Onça", "Carcará", "Saci", "Calango"],
    traits: ["Veloz", "Turbo", "Brabo", "Ligeiro", "Ninja", "Elétrico", "Valente", "Danado"],
  },
};

export function generateNickname(locale: Locale, previous = ""): string {
  const { animals, traits } = words[locale];
  const animal = animals[Math.floor(Math.random() * animals.length)];
  const trait = traits[Math.floor(Math.random() * traits.length)];
  const suffix = 10 + Math.floor(Math.random() * 90);
  const name = `${animal}${trait}${suffix}`;
  return name === previous ? `${animal}${trait}${10 + ((suffix - 9) % 90)}` : name;
}

// Keep the existing storage key so the rename preserves chosen nicknames.
export function rememberNickname(name: string): void {
  try {
    localStorage.setItem("pile-name", name);
  } catch {
    // A nickname remains usable when browser storage is unavailable.
  }
}

export function loadNickname(locale: Locale): string {
  try {
    const saved = localStorage.getItem("pile-name")?.trim();
    if (saved && saved.length <= 20) return saved;
  } catch {
    // Use a generated nickname on devices without persistent storage.
  }
  const name = generateNickname(locale);
  rememberNickname(name);
  return name;
}
